(() => {
  const sections = document.querySelectorAll('.home-brand-showcase');

  sections.forEach((section) => {
    const videos = section.querySelectorAll('[data-brand-showcase-video]');

    if (!videos.length || !('IntersectionObserver' in window)) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          const phone = video.closest('.home-brand-showcase__phone');

          if (entry.isIntersecting) {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          } else {
            video.pause();
            if (phone) {
              phone.classList.remove('is-playing');
            }
          }
        });
      },
      {
        threshold: 0.45,
      }
    );

    videos.forEach((video) => {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.addEventListener('playing', () => {
        const phone = video.closest('.home-brand-showcase__phone');
        if (phone) {
          phone.classList.add('is-playing');
        }
      });
      video.addEventListener('pause', () => {
        const phone = video.closest('.home-brand-showcase__phone');
        if (phone) {
          phone.classList.remove('is-playing');
        }
      });
      observer.observe(video);
    });
  });
})();
